export default "__VITE_ASSET__CLFez3Ay__"